import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC, useCallback } from 'react';
import { ConfirmDisableOfficeSettingModal } from './ConfirmDisableOfficeSettingModal';
import { ConfirmEnableOfficeSettingModal } from './ConfirmEnableOfficeSettingModal';
import { useOfficeSettingActions } from './hooks/useOfficeSettingActions';
import { useOfficeSettingModalControl } from './hooks/useOfficeSettingModalControl';

type OfficeSettingActionsProps = {
  isEnabled?: boolean;
  isDisabled?: boolean;
};

export const OfficeSettingActions: FC<OfficeSettingActionsProps> = ({
  isEnabled = false,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const {
    openModal,
    handleOpenEnableModal,
    handleOpenDisableModal,
    handleCloseModal,
  } = useOfficeSettingModalControl();

  const {
    handleConfirmEnable,
    handleConfirmDisable,
    isEnablePending,
    isDisablePending,
  } = useOfficeSettingActions({
    onClose: handleCloseModal,
  });
  const onConfirmEnable = useCallback(() => {
    handleConfirmEnable();
  }, [handleConfirmEnable]);

  const onConfirmDisable = useCallback(() => {
    handleConfirmDisable();
  }, [handleConfirmDisable]);

  return (
    <>
      {isEnabled ? (
        <ButtonV2
          color='danger'
          isSecondary
          isDisabled={isDisabled}
          size='xs'
          onClick={handleOpenDisableModal}
        >
          {t('ai_agents_setting_main_setting_use_stop_button_label')}
        </ButtonV2>
      ) : (
        <ButtonV2
          color='primary'
          isSecondary
          isDisabled={isDisabled}
          size='xs'
          onClick={handleOpenEnableModal}
        >
          {t('ai_agents_setting_main_setting_use_start_button_label')}
        </ButtonV2>
      )}
      <ConfirmEnableOfficeSettingModal
        open={openModal === 'enable'}
        onClose={handleCloseModal}
        onConfirm={onConfirmEnable}
        isPending={isEnablePending}
      />
      <ConfirmDisableOfficeSettingModal
        open={openModal === 'disable'}
        onClose={handleCloseModal}
        onConfirm={onConfirmDisable}
        isPending={isDisablePending}
      />
    </>
  );
};
